export default __webpack_public_path__ + "static/media/home_section_2.99faa4e0.jpg";